<template>
    <div class="tooltip-box">
        <slot />
        <div class="tooltip" :class="{'hidden': hidden}">
            <span class="triangle"></span>
            {{ text }}
        </div>
    </div>
</template>

<style>
.tooltip-box {
    position: relative
}
.tooltip {
    background: rgba(0,0,0, .6);
    color: #ffffff;
    font-size: 12px;
    text-align: center;
    padding: 2px 12px;
    border-radius: 4px;
    bottom: calc(100% + 11px);
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
}
.triangle {
    border-width: 0 6px 6px;
    border-color: transparent;
    border-bottom-color: rgba(0,0,0, .6);
    position: absolute;
    bottom: -6px;
    transform: rotate(180deg) translateX(-50%);
    left: calc(50% - 12px)
}
</style>

<script>
export default {
    name: 'Tooltip',
    props: {
        text: String,
        hidden: {
            type: Boolean,
            default: true
        }
    }
}
</script>
